import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import Loader from './Loader';
import Pagination from './Pagination';
import AppContext from '../Context/AppContext';

const StorageListItem = ({ data }) => {
    const { mapUrl } = useContext(AppContext)
    const [page, setPage] = useState(1);
    const [load, setLoad] = useState(false);

    const [items, setItems] = useState(null)
    const [pagination, setPagination] = useState(null)

    const [select, setSelect] = useState([])
    const [error, setError] = useState([])


    const goToPage = (p) => {
        setPage(p)
        init(p)
    };

    const init = async (p = null) => {
        if (!load) {
            setLoad(true)
            const response = await axios.get("http://" + data.adresse + "/api/pagination?token=" + data.token + "&page=" + p || page);
            if (response?.data) {
                setItems(response.data?.data)
                setError([])

                setPagination({
                    total: response.data.total,
                    perPage: response.data.perPage
                })
                setSelect([])

            }
            setLoad(false)
        }
    }
    const saveCdn = async () => {
        if (select?.length > 0 && !load && mapUrl.add_restore) {
            setLoad(true)
            for (const element of select) {
                const response = await axios.post(mapUrl.add_restore, { name: element, storage: data.name });
                console.log(response);

                if (response?.data?.status !== "ok") {
                    setError(prev => [...prev, { name: element, status: response?.data.status }])

                }
            }
            setLoad(false);
        }
    }
    useEffect(() => {
        if (data) {
            init()
        }
    }, [data])
    console.log(error);

    return (<div className='df fdc'>
        <div className='py1 df aic gap1'>
            <button onClick={() => setSelect(items)} className='bcw px1 py1 cb fm cp' >Tout selectionner</button>
            {select?.length > 0 && (
                <>
                    <button onClick={() => setSelect([])} className='bcw px1 py1 cb fm cp'>Tout déselectionner</button>
                    <button className='px1 py1 bcs fm cw cp' onClick={() => saveCdn()}>Enregistrer</button>
                </>
            )}
        </div>
        {pagination && (
            <Pagination page={page} setPage={setPage} goToPage={goToPage} total={pagination.total} perPage={pagination.perPage} />
        )}
        <div className='oys df fdc flex1'>
            {load && (<div className='df aic jcc'><Loader /></div>)}

            {!load && items?.length > 0 && items.map((item, i) => (
                <button onClick={() => setSelect(prev =>
                    (prev && prev.includes(item))
                        ? prev.filter(i => i !== item)   // si présent → retirer
                        : [...prev, item]                // si absent → ajouter
                )} key={page + "__item" + i} className={`px1 py1 ${select?.includes(item) ? "bcs" : ""} ${(error?.length > 0 && error?.find(e => e.name == item.name)) ? "bce" : ""} `}>
                    <p className='fm fs12 cw '>{item} {(error?.length > 0 && error?.find(e => e.name == item.name)) ? `/ ${error.find(e => e.name == item.name)?.status}` : ""}</p>
                </button>
            ))}

        </div>

    </div>
    );
};

export default StorageListItem;